import { RecordTag } from '@/constants/documentTags.ts';

type DocumentPayload = {
	file?: File;
	description?: string;
	tags?: RecordTag[] | null;
};

/**
 * Creates a FormData payload for uploading a document
 * Supports both file uploads and text-only documents with description
 */
export function makeDocumentPayload(options: DocumentPayload): FormData {
	const formData = new FormData();
	const { file, description, tags } = options;

	// Add file if provided
	if (file) {
		formData.append('file', file);
	}

	// Add description if provided
	if (description) {
		formData.append('description', description);
	}

	if (tags && tags.length > 0) {
		// Append each tag to the form data
		tags.forEach((tag) => {
			formData.append('tags', tag);
		});
	}
	return formData;
}
